import { Box, Stepper, Step, StepLabel, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { localSeoTexts } from './localSeoTexts';
import { LocalSeoStepperCss } from './localSeoCss';
import Loader from 'src/common/config/Loader';
import { lazy } from 'react';
// Named Exports
const ConnectBusinessProfileModal = Loader(
  lazy(() =>
    import('./ConnectBusinessProfileModal').then((module) => ({
      default: module.ConnectBusinessProfileModal
    }))
  )
);
const LocalSeoLocationCard = Loader(
  lazy(() =>
    import('./LocalSeoLocationCard').then((module) => ({
      default: module.LocalSeoLocationCard
    }))
  )
);
const MapRankTrackerStep = Loader(
  lazy(() =>
    import('./MapRankTrackerStep').then((module) => ({
      default: module.MapRankTrackerStep
    }))
  )
);
import { SqSpSiteSelectorComponent } from '../onBoarding/SqSpSiteSelectorComponent';
import { localStorageMethod } from 'src/common/config/FunctionHelper';

const steps = ['GBP Connection', 'Map Rank Tracker'];

export const LocalSeoStepper = () => {
  let localSeoSection: any = useSelector(
    (state: RootState) => state.keywordResearch.localSeoSection
  );
  let locationsData =
    useSelector((state: RootState) => state.localSeo.reduxLocationsData) ??
    null;
  let reduxFilteredLocationsData: any =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? [];
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const isLocalSeoSqspFlow = localStorageMethod(
    'get',
    'is_local_seo_sqsp_flow'
  );
  const activeStep = localSeoSection === 7 ? 1 : 0;

  return (
    <>
      <Box sx={LocalSeoStepperCss?.mainBox}>
        <Typography sx={LocalSeoStepperCss?.mainTitle}>
          {localSeoTexts?.connectGoogleBusinessProfile}
        </Typography>
        <Box px={4} sx={{ marginBottom: '32px' }}>
          <Stepper activeStep={activeStep} sx={LocalSeoStepperCss?.stepper}>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel
                  StepIconComponent={() => (
                    <Box
                      sx={{
                        ...LocalSeoStepperCss?.stepperIcon,
                        border:
                          activeStep > index
                            ? '2px solid var(--color-secondary)'
                            : activeStep == index
                            ? '2px solid var(--color-secondary)'
                            : '2px solid var(--color-text-placeholder)',
                        backgroundColor:
                          activeStep > index
                            ? 'var(--color-secondary)'
                            : activeStep == index
                            ? 'rgba(37, 211, 177, 0.1)'
                            : 'transparent',
                        color:
                          activeStep > index
                            ? 'white'
                            : activeStep == index
                            ? 'var(--color-primary)'
                            : 'var(--color-text-placeholder)'
                      }}
                    >
                      <Typography sx={LocalSeoStepperCss?.stepNumSx}>
                        {String(index + 1).padStart(2, '0')}
                      </Typography>
                    </Box>
                  )}
                >
                  <Typography
                    sx={{
                      ...LocalSeoStepperCss?.stepLabelSx,
                      fontWeight: activeStep == index ? 600 : 500,
                      color:
                        activeStep > index
                          ? 'var(--color-primary)'
                          : activeStep == index
                          ? 'var(--color-primary)'
                          : 'var(--color-text-placeholder)'
                    }}
                  >
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          <Box mt={4}>
            {/* Step 1: Connection or Location Card */}
            {localSeoSection === 0 && (
              <>
                <ConnectBusinessProfileModal />

                {(userDetails?.is_local_seo ||
                  userDetails?.is_local_seo_signUp) &&
                  !isLocalSeoSqspFlow && (
                    <SqSpSiteSelectorComponent isLocalSeo={true} />
                  )}
              </>
            )}
            {localSeoSection === 1 && (
              <LocalSeoLocationCard locationsData={locationsData} />
            )}

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {/* Step 2: Map Rank Tracker (with internal tabs) */}
              {localSeoSection === 7 && <MapRankTrackerStep />}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
